import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Server Metrics")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  style: {"height":"300px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "card-body"
}
const _hoisted_6 = { class: "row row-cols-5" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_11 = { class: "d-flex align-items-center ms-3" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "d-flex gap-5 justify-content-between align-items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "CPU:", -1)
const _hoisted_17 = { class: "d-flex gap-5 justify-content-between align-items-center mt-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "Mem:", -1)
const _hoisted_19 = { class: "d-flex gap-5 justify-content-between align-items-center mt-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "Disk:", -1)
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "me-15" }, "Load:", -1)
const _hoisted_24 = { class: "d-flex justify-content-between w-50" }

import { onMounted, onUnmounted, ref } from "vue";
import ServerServices from "../services/ServerServices";
import notification from "@/core/plugins/notification";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { useStore } from "@/store";
import Clipboard from "clipboard";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerIndex',
  setup(__props) {

const store = useStore();
const user = store.state.AuthModule.user;
const autoRefreshIds = ref<any>([]);
const localStorageKey = `server_auto_refresh_${user.tenancy}`;
const isLoading = ref(true);
const data = ref<any[]>([]);
const criteria = ref({
  status: 0,
  size: 100,
});

const copy = (value) => {
  Clipboard.copy(value as string);
  ElMessage("Copied");
};

const autoRefreshSwitch = async (item) => {
  try {
    if (item.autoRefresh == false) {
      autoRefreshIds.value = autoRefreshIds.value.filter(
        (id) => id !== item.id
      );
      clearInterval(item.intervalId);
    } else {
      autoRefreshIds.value.push(item.id);
      await refreshMetricsData(item);
    }
    localStorage.setItem(localStorageKey, JSON.stringify(autoRefreshIds.value));
  } catch (e) {
    console.log(e);
  }
};

const fetchData = async () => {
  try {
    const res = await ServerServices.getServersData(criteria.value);

    data.value = res.data;
    data.value = data.value.map((item) => {
      return {
        ...item,
        isRefreshing: false,
        autoRefresh: autoRefreshIds.value.includes(item.id),
      };
    });
  } catch (error) {
    console.log(error);
    notification.danger();
  }
};

const getMetricsData = async (item) => {
  try {
    const res = await ServerServices.getServerMetrics({ id: item.id });
    var disk = JSON.parse(res.metrics.diskJson);

    item.metrics = {
      cpu: JSON.parse(res.metrics.cpuJson),
      memory: JSON.parse(res.metrics.memoryJson),
      disk: disk.filter((item) => item.mnt_point === "/")[0],
      load: JSON.parse(res.metrics.loadJson),
      isLoading: false,
    };
    item.metrics = {
      cpu: {
        ...item.metrics.cpu,
        percent: Math.floor(item.metrics.cpu.total),
      },
      memory: {
        ...item.metrics.memory,
        percent: Math.floor(
          (item.metrics.memory.used / item.metrics.memory.total) * 100
        ),
      },
      disk: {
        ...item.metrics.disk,
      },
      load: {
        ...item.metrics.load,
      },
    };
    console.log("metrics", item.metrics);
    item.isRefreshing = true;
  } catch (error) {
    console.log(error);
    notification.danger();
  }
};

const refreshMetricsData = (item) => {
  item.isLoading = true;
  if (item.intervalId) {
    clearInterval(item.intervalId);
    item.intervalId = null;
  }

  const fetchDataAndRestartTimer = () => {
    getMetricsData(item);

    let timeLeft = 30;
    item.metrics.timer = timeLeft;

    item.intervalId = setInterval(() => {
      timeLeft--;
      item.metrics.timer = timeLeft;

      if (timeLeft <= 0) {
        clearInterval(item.intervalId);
        fetchDataAndRestartTimer(); // Refresh data and restart the timer
      }
    }, 1000);
  };
  item.isLoading = false;
  fetchDataAndRestartTimer(); // Initial call to start the process
};

const progressColor = (value) => {
  if (value < 50) {
    return "#67C23A";
  } else if (value < 80) {
    return "#E6A23C";
  } else {
    return "#F56C6C";
  }
};

onMounted(async () => {
  isLoading.value = true;
  autoRefreshIds.value = JSON.parse(
    localStorage.getItem(localStorageKey) || "[]"
  );
  await fetchData();

  for (let i = 0; i < autoRefreshIds.value.length; i++) {
    const item = data.value.find((item) => item.id == autoRefreshIds.value[i]);
    if (item) {
      await refreshMetricsData(item);
    }
  }
  isLoading.value = false;
});

onUnmounted(() => {
  autoRefreshIds.value.forEach((id) => {
    const item = data.value.find((item) => item.id == id);
    if (item) {
      clearInterval(item.intervalId);
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(ScaleLoader, { color: '#ffc730' })
        ]))
      : (!isLoading.value && data.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_NoDataBox)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col mb-4",
                  key: index
                }, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h3", _hoisted_9, _toDisplayString(item.name), 1),
                      (item.stat == 'glances')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createTextVNode(" AR "),
                              _createVNode(_component_el_switch, {
                                modelValue: item.autoRefresh,
                                "onUpdate:modelValue": ($event: any) => ((item.autoRefresh) = $event),
                                class: "ms-1",
                                onChange: ($event: any) => (autoRefreshSwitch(item))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: ($event: any) => (copy(item.ip))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.ip), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          size: "small",
                          class: "ms-2",
                          onClick: ($event: any) => (copy(item.region))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.region), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          size: "small",
                          class: "ms-2",
                          onClick: ($event: any) => (copy(item.instance))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.instance), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      (item.isRefreshing)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(item.metrics.timer) + " seconds left for next refresh ", 1),
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createVNode(_component_el_progress, {
                                class: "w-75",
                                "stroke-width": 16,
                                percentage: item.metrics.cpu.percent,
                                color: progressColor(item.metrics.cpu.percent)
                              }, null, 8, ["percentage", "color"])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createVNode(_component_el_progress, {
                                class: "w-75",
                                "stroke-width": 16,
                                percentage: item.metrics.memory.percent,
                                color: progressColor(item.metrics.memory.percent)
                              }, null, 8, ["percentage", "color"])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createVNode(_component_el_progress, {
                                class: "w-75",
                                "stroke-width": 16,
                                percentage: item.metrics.disk.percent,
                                color: progressColor(item.metrics.disk.percent)
                              }, null, 8, ["percentage", "color"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", null, _toDisplayString(item.metrics.load.min1.toFixed(2)), 1),
                                  _createElementVNode("div", null, _toDisplayString(item.metrics.load.min5.toFixed(2)), 1),
                                  _createElementVNode("div", null, _toDisplayString(item.metrics.load.min15.toFixed(2)), 1)
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])), [
                    [_directive_loading, item.isLoading]
                  ])
                ]))
              }), 128))
            ])
          ]))
  ]))
}
}

})